module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCool.d16166c.webp";